export const MONTH_LABELS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const fmtSEK = (v) =>
  v == null ? "—" : `${new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 0 }).format(Math.round(v))}`;

export const fmtPct = (v) => (v == null ? "N/A" : `${v.toFixed(1)}%`);
export const fmtMonths = (v) => (v == null ? "N/A" : v.toFixed(1));
export const fmtRate = (v) => (v == null ? "N/A" : `${fmtSEK(v)} kr/h`);

// Split a monthly series into actual (solid) and forecast (dashed) segments that
// share the boundary point so the line stays continuous (§7).
export function splitActualForecast(months, key) {
  const boundary = months.reduce((acc, m) => (m.state === "ACTUAL" ? m.month : acc), 0);
  return months.map((m) => ({
    month: MONTH_LABELS[m.month - 1],
    [`${key}_a`]: m.month <= boundary ? m[key] : null,
    [`${key}_f`]: m.month >= boundary ? m[key] : null,
  }));
}

export function cumulative(months, key) {
  let run = 0;
  return months.map((m) => {
    run += m[key] || 0;
    return { ...m, [`${key}_cum`]: run };
  });
}
